/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-10 15:54:24
 * @FilePath: /portal2/unifyxp-v2-store-portal/src/components/Layouts/Row/Row.tsx
 */
import React, { ReactNode } from 'react';
import css from './css.less';
import { Row, Col } from 'antd';
interface IElements {
  child: ReactNode;
  containerClassName?: string;
  splitClassName?: string;
  containerProps?: { [propName: string]: any };
  removeLeftPadding?: boolean;
}
interface IProps {
  elements: IElements[];
  containerProps?: { [propName: string]: any };
  containerClassName?: string;
  hasBottomBorder?: boolean;
  borderBottomClassName?: string;
}
const RowContainer = (props: IProps) => {
  const {
    elements,
    containerClassName,
    containerProps,
    hasBottomBorder,
    borderBottomClassName,
  } = props;
  const ele = React.useMemo(() => {
    return (elements || []).map((i: IElements, index: number) => {
      const {
        child,
        containerClassName,
        //splitClassName,
        containerProps,
        removeLeftPadding,
      } = i || {};
      if (index > 0 || !removeLeftPadding) {
        return (
          <React.Fragment key={index}>
            {/* <Col className={`${css.splitContainer} ${splitClassName || ''}`} /> */}
            <Col
              id='col'
              className={`${css.eleContainer} ${containerClassName || ''}`}
              {...containerProps}>
              {child}
            </Col>
          </React.Fragment>
        );
      } else {
        <Col
          key={index}
          className={`${css.eleContainer} ${containerClassName || ''}`}
          {...containerProps}>
          {child}
        </Col>;
      }
    });
  }, [elements]);
  return (
    <Row
      {...containerProps}
      className={`${css.container} ${containerClassName || ''}`}>
      {ele}
      {hasBottomBorder && (
        <div className={`${css.borderBottom} ${borderBottomClassName || ''}`} />
      )}
    </Row>
  );
};
export default RowContainer;
